<template>
    <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900">Job posting access</h3>
                <p class="mt-1 text-sm leading-5 text-gray-600">
                    Do you want posting to be public or private?
                </p>
            </div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
                <div class="px-4 py-5 bg-white sm:p-6">
                    <div class="grid grid-cols-6 gap-6">
                        <div v-if="enabled()" class="col-span-6">
                            <label for="private_posting_url" class="block text-sm font-medium leading-5 text-gray-700">
                                Private posting URL
                            </label>
                            <div class="mt-1 relative rounded-md shadow-sm">
                                <input id="private_posting_url" type="text" readonly
                                       class="form-input block w-full sm:text-sm sm:leading-5"
                                       :value="`${board.url}/new?token=${getToken()}`">
                            </div>
                        </div>
                        <div v-if="!enabled()" class="col-span-6 sm:col-span-3">
                            Job posting is open to public.
                        </div>
                    </div>
                </div>
                <form @submit.prevent="submit">
                    <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6">
                        <Button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            {{ enabled() ? 'Make it public': 'Make it private' }}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Button from "@/Jetstream/Button";
    import ActionMessage from "@/Jetstream/ActionMessage";
    import InputError from "@/Jetstream/InputError";

    export default {
        name: "EditPrivatePosting",
        components: {
            Button,
            ActionMessage,
            InputError
        },
        props: {
            board: Object,
            errors: Object
        },
        data() {
            return {
                form: this.$inertia.form({}, {
                    resetOnSuccess: false
                })
            }
        },
        methods: {
            enabled() {
                return this.board.private_post_token != null;
            },
            getToken() {
                return this.board.private_post_token;
            },
            submit() {
                const path = this.enabled() ? 'disable-private-posts' : 'enable-private-posts';
                this.form.post(`/settings/${path}`, {preserveScroll: true});
            }
        }
    }
</script>
